import { apiConfig } from "@grindex-common/helpers/apiConfig";

function init() {
	const initEpiserverFormsDownloadForm = () => {
		const directDownloadUrl = `/${apiConfig.apiLanguage}/api/CaseStudies/CaseStudyForm/DirectDownloadFromId/${apiConfig.apiNode}`;

		if (typeof window.$$epiforms !== "undefined") {
			window.onload = function () {
				const $epiForms = window.$$epiforms(".EPiServerForms");
				$epiForms.on("formsSubmitted ", function () {
					$.ajax({
						url: directDownloadUrl,
						data: { contentLink: apiConfig.apiNode },
						success: function (html) {
							document.querySelector(".download-pdf-form").innerHTML = html;
							document.querySelector(".download-pdf").classList.add("form-submitted");
						},
					});
				});
			};
		}
	};

	initEpiserverFormsDownloadForm();
}

export default {
	view: "caseStudyPage",
	init,
};
